const ELEMENT_TYPE = {
  DESIGNER: 'designer',
  YEAR: 'year',
  MOMENT: 'moment',
  PRODUCT_GROUP: 'productgroup',
  PRODUCT: 'product',
  ROOM: 'room',
  ROOM_PREVIEW: 'roomPreview',
  DUMMY: 'dummy',
  DISCOVER: 'discover',
  DESIGN: 'design',
};

module.exports = {
  ELEMENT_TYPE,
  NAVIGATION_FROM: {
    TIMELINE: 'timeline',
    ROOM: 'room',
    LEFT: 'left',
    RIGHT: 'right',
  },
  PATHS: {
    TIMELINE: '/timeline',
    DESIGNER: '/timeline/designer',
    PRODUCT: '/timeline/product',
    MOMENT: '/timeline/moment',
    ROOM: '/timeline/roomInteraction',
  },
  ROUTES: [
    {
      route: '/timeline/roomInteraction/:id',
      type: ELEMENT_TYPE.ROOM,
    },
    {
      route: '/timeline/moment/:id',
      type: ELEMENT_TYPE.MOMENT,
    },
    {
      route: '/timeline/designer/:id',
      type: ELEMENT_TYPE.DESIGNER,
    },
    {
      route: '/timeline/product/:id',
      type: ELEMENT_TYPE.PRODUCT,
    },
    {
      route: '/timeline/product/:id/:roomId',
      type: ELEMENT_TYPE.PRODUCT,
    },
  ],
  THEME: {
    BLACK: 'black',
    WHITE: 'white',
  },
  YEAR_ANIMATIONS_DIRECTION: {
    FORWARD: 'runAnimationForwards',
    BACKWARD: 'runAnimationBackwards',
  },
};
